import { useGetCbtTestSessionLazyQuery } from '@/types/vue-apollo-helpers';
import type { Query, QueryGetCbtTestSessionArgs } from '@/types/composition-functions';

export const useCBTTestSession = ({
  autoFetch = true,
  variables,
}: {
  autoFetch?: boolean;
  variables?: Ref<QueryGetCbtTestSessionArgs | undefined> | (() => QueryGetCbtTestSessionArgs);
}) => {
  const { result, loading, load, refetch, error } = useGetCbtTestSessionLazyQuery(
    variables as QueryGetCbtTestSessionArgs,
  );
  if (autoFetch) load();

  const session = computed(() => result.value?.getCBTTestSessionResult || null);

  return {
    session,
    loading,
    load,
    refetch,
    error,
  };
};
